import { useContext } from 'react'
import PropTypes from 'prop-types'

import ShapeThumb from 'reactGarden/common/prop-types/ThumbContent'
import { HeartIcon } from 'reactGarden/HeartIcon'
import { ThumbTitle, ThumbAuthor } from 'reactGarden/common/components/ThumbFragments'

import { WishlistContext } from 'reactSite/Wishlist/context'

const ThumbInfo = ({ data: { id, inWishList, publishDate, title, url } }) => {
  const wishlistValues = useContext(WishlistContext)

  const {
    onPressHeart,
    isOnWishlist
  } = wishlistValues

  const wishlistAction = () => onPressHeart({ inWishList, id }, 'contents')

  return (
    <div className="content-thumbnail-info">
      <a className="link" href={ url } title={ title }>
        <ThumbTitle text={ title } />
      </a>
      <ThumbAuthor date={ publishDate } />
      <HeartIcon
        onClick={ wishlistAction }
        isActive={ isOnWishlist(id) }
      />
    </div>
  )
}

ThumbInfo.propTypes = {
  data: PropTypes.shape({ ...ShapeThumb }).isRequired
}

export default ThumbInfo
